import axios from '@/axios.js';

export const collectionApi = {
  getCollections(payload) {
    return axios.get(`admin/collections`, {
      params: payload,
    });
  },
  addCollection(body) {
    return axios.post(`admin/collections`, body);
  },
  updateCollection(id, body) {
    return axios.patch(`admin/collections/${id}`, body);
  },
  getCollection(id) {
    return axios.get(`admin/collections/${id}`);
  },
  deleteCollection(id) {
    return axios.delete(`admin/collections/${id}`);
  },
  updateSequence(body) {
    return axios.patch(`admin/collections/sequence`, body);
  },
};
